import { rootApi } from './rootApi';

export interface AnalyticsEvent {
  name: string;
  params: unknown;
}

interface LogEventArgs {
  organisationDomain: string;
  event: AnalyticsEvent;
  clientId: string;
}

export const analyticsProxyApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    logEvent: builder.mutation<void, LogEventArgs>({
      query: ({ organisationDomain, event, clientId }) => ({
        url: `/webapp/analytics/event?organisation=${organisationDomain}`,
        method: 'POST',
        body: { event, clientId },
      }),
    }),
  }),
});

export const { useLogEventMutation } = analyticsProxyApi;
